import type EditorEventManager from '../engine/EditorEventManager'
import type AutoSaveHandler from '../engine/handlers/AutoSaveHandler'
import type { ProjectSavedEvent } from '../engine/handlers/ProjectHandler'

export function isTemplateProjectId(id: string): boolean {
  return !isNaN(Number(id))
}

/** A resumable route requires completion of the owning project's local save. */
export function subscribeToSavedProjectRoute(
  editor: Pick<EditorEventManager, 'on' | 'off'>,
  autoSave: Pick<AutoSaveHandler, 'projectId' | 'ephemeral'>,
  getRouteId: () => string | null,
  navigate: (projectId: string) => void,
): () => void {
  const onSaved = ({ projectId }: ProjectSavedEvent) => {
    const routeId = getRouteId()
    if (!projectId || autoSave.ephemeral || projectId !== autoSave.projectId ||
        (routeId && !isTemplateProjectId(routeId))) return
    navigate(projectId)
  }
  editor.on('project:saved', onSaved)
  return () => editor.off('project:saved', onSaved)
}
